import { ComponentProps } from 'react';
import { StyleSheet, TextStyle } from 'react-native';
import { Text as TextLib } from '@ui-kitten/components';

export const Text = ({ align, style, disabled, truncateOverflow, ...textProps }: TextProps) => {
	return (
		<TextLib
			style={[
				truncateOverflow && styles.truncate,
				style,
				alignStyle(align),
				disabled && styles.disabled,
			]}
			{...textProps}
		/>
	);
};

const styles = StyleSheet.create({
	disabled: {
		opacity: 0.3,
	},
	truncate: {
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		whiteSpace: 'nowrap',
	},
});

const alignStyle = (align?: TextStyle['textAlign']) => ({
	textAlign: align,
});

export type TextProps = ComponentProps<typeof TextLib> & {
	align?: TextStyle['textAlign'];
	disabled?: boolean | null;
	truncateOverflow?: boolean;
};
